@if(show){
    @if(filter.baseNamedFilter){
        <div class="savedFilterManager">
            <h4 class="mb-0 pe-3">
                {{filter.filterTitle}}
                <small> {{'filter_manager.pre_defined' | translate}}</small>
                @if(filter.default) {
                    <small class="default-namedFilter">{{'filters_setting.default' | translate}}</small>
                }
                @else {
                    <small>
                        <a (click)="callSetAsDefault({id: filter.id})" class="set-default-namedFilter">{{'filters_setting.set_as_default' | translate}}</a>
                    </small>
                }
                <span class="float-end closeManager" (click)="closeManager()"><i class="far fa-times"></i></span>
            </h4>
        </div> 
    }
    @else{ <!-- custom filter cases-->
        <div class="savedFilterManager">
            @switch(managerMode){
                @case('create'){
                    <h4 class="mb-0 pe-3">
                        <span>
                            {{'filter_manager.new' | translate}}
                            <small><i>- {{'filter_manager.description' | translate}}</i></small>
                        </span>
                        <span class="float-end closeManager" (click)="closeManager()"><i class="far fa-times"></i></span>
                    </h4>
                }
                @case('forward'){
                    <h4 class="mb-0 pe-3">
                        <span>{{'filter_manager.forward' | translate}}</span>
                        <span class="float-end closeManager" (click)="closeManager()"><i class="far fa-times"></i></span>
                    </h4>
                }
                @case('update'){
                    <h4 class="mb-0 pe-3">
                        {{filter.name}}
                        <small> {{'filter_manager.advanced' | translate}}</small>
                        @if(filter.default) {
                            <small class="default-namedFilter">{{'filters_setting.default' | translate}}</small>
                        }
                        @else {
                            <small>
                                <a (click)="openModalInDefaultMode(filter)" class="set-default-namedFilter">{{'filters_setting.set_as_default' | translate}}</a>
                           </small>
                        }
                        <span class="float-end closeManager" (click)="closeManager()"><i class="far fa-times"></i></span>
                    </h4>
                }
            }
        
            <div class="savedFilterManager-content mt-3">
                <tm-filter-editor class="pe-5"
                              [filter]="filter.decodedFilter"
                              [orgUnits]="orgUnits"
                              (filterChange)="onFilterChange($event)">
                </tm-filter-editor>

                @if(isFilterUpdated || managerMode === 'forward') {
                    <div class="d-flex justify-content-end align-items-baseline">
                        <button type="button"
                                class="btn btn-primary"
                                (click)="save(filter)">
                            @if(managerMode === 'create' || managerMode === 'forward') {
                                <span>{{'filters_setting.create' | translate}}</span>
                            }
                            @if(managerMode === 'update') {
                                <span>{{'filters_setting.save' | translate}}</span>
                            }
                        </button>
                    </div>
                }
            </div>
        </div>
    }
}
@else{ <!--not show-->
    @if(filter.baseNamedFilter && managerInDialog) {
        <a class="filterViewLink text-secondary text-lowercase" (click)="callSetAsDefault({id: filter.id})">{{'filters_setting.set_as_default' | translate}}</a>
    }@else {
        <a class="filterViewLink" (click)="displayManager()">{{'filters_setting.details' | translate}}</a>
    }
}
